class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.closeTimer = null;
        this.items = this.querySelectorAll('.header-menu.mega');
        this.menus = this.querySelectorAll('.header-menu-content');
        this.items.forEach((item) => {
            item.addEventListener('mouseenter', this.menuOpen.bind(this));
            item.addEventListener('mouseleave', this.menuClose.bind(this));
        });
        this.menus.forEach((menu) => {
            menu.addEventListener('mouseenter', this.menuEnter.bind(this));
            menu.addEventListener('mouseleave', this.menuClose.bind(this));
        });
    }

    menuClose(event) {
        let $self = this
        // document.querySelector('body').classList.add('desktop-menu-closing');
        this.timer = setTimeout(function(){
            document.querySelector('body').classList.remove('desktop-menu-open');
            document.querySelector('body').classList.add('desktop-menu-closing');
            $self.items.forEach((item) => {
                item.classList.remove('active');
            })
            $self.closeTimer = setTimeout(function(){
                document.querySelector('body').classList.remove('desktop-menu-closing');
            }, 400)
        }, 200);
    }

    menuEnter(event) {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        document.querySelector('body').classList.remove('desktop-menu-closing');
    }

    menuOpen(event) {
        var clickedItem = event.target;
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        clickedItem.classList.add('active');
        document.querySelector('body').classList.add('desktop-menu-open');
        document.querySelector('body').classList.remove('desktop-menu-closing');
        this.items.forEach((item) => {
            if(item != clickedItem) {
                item.classList.remove('active');
            }
        })
    }
}

customElements.define('mega-menu', MegaMenu);